import { useQueryClient } from "@tanstack/react-query";
import * as React from "react";
import { connect, HandleThunkActionCreator } from "react-redux";
import { Link } from "react-router-dom";
import { dispatchSwitchOperator } from "../../../actions/common/session";
import OperatorInterface from "../../../interfaces/OperatorInterface";
import CircleIcon from "../../atoms/CircleIcon/index";
import styles from "./styles.scss";

interface Props {
  operator: OperatorInterface;
  isCurrentOperator: boolean;
  switchOperator: HandleThunkActionCreator<typeof dispatchSwitchOperator>;
}

const CurrentUsername = (props: Props): React.ReactElement<any> => {
  return (
    <Link
      to="/settings/profile"
      className={`${styles.root} ${styles.isCurrent}`}
    >
      <div className={styles.left}>
        <CircleIcon
          className={styles.iconAccount}
          iconProps={{
            name: "icon-account",
            iconClassName: styles.iconAccount,
          }}
        />
      </div>
      <div className={styles.right}>
        <p className={styles.name}>{props.operator.fullName}</p>
        <p className={styles.link}>アカウント編集</p>
      </div>
    </Link>
  );
};

const OtherUsername = (props: Props) => {
  const queryClient = useQueryClient();

  const handleClick = () => {
    if (props.isCurrentOperator) {
      return;
    }

    props.switchOperator(props.operator, {
      onSuccess: () => {
        // 変更前のオペレーターのキャッシュが残らないようにリセットする
        queryClient.resetQueries();
      },
    });
  };

  return (
    <div className={styles.root} onClick={handleClick}>
      <div className={styles.left}>
        <CircleIcon
          className={styles.iconAccount}
          iconProps={{
            name: "icon-account",
            iconClassName: styles.iconAccount,
          }}
        />
      </div>
      <div className={styles.right}>
        <p className={styles.name}>{props.operator.fullName}</p>
      </div>
    </div>
  );
};

const HeaderAccountUsername = (props: Props) => {
  if (props.isCurrentOperator) {
    return <CurrentUsername {...props} />;
  } else {
    return <OtherUsername {...props} />;
  }
};

const actions = {
  switchOperator: dispatchSwitchOperator,
};

export default connect(null, actions)(HeaderAccountUsername);
